var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VirtualList',{attrs:{"list":_vm.list,"dataComponent":_vm.dataComponent,"finished":_vm.finished},on:{"getData":_vm.getData}})}
var staticRenderFns = []

export { render, staticRenderFns }